import { configureStore } from '@reduxjs/toolkit'
import appCommonReduce from './features/appCommonSlice'

export default configureStore({
  reducer: {
    appCommon: appCommonReduce
    // 可以在下边加其他的Reduce
  }
})
